import axios from "axios";

// Local 
//axios.defaults.baseURL = "https://localhost:44311/api/v1";
//Linzy:20251217 Replace above because cannot run on localhost with https
//axios.defaults.baseURL = "http://localhost:44311/api/v1";

//acccentlabels test
//axios.defaults.baseURL = "https://mioapitest.accentlabels.com/api/v1";

//accentlabels
axios.defaults.baseURL = "https://mioapi2.accentlabels.com/api/v1";